// 全局轻量提示（自实现，替代 element-ui 的 $message）
// 用法：this.$toast({ type: 'success', message: '...' }) 或 this.$toast.success('...')
import Vue from 'vue'

// 单例响应式 store：必须在模块顶层创建。
// 若改到 install(Vue) 里创建再以 let 导出，App.vue 先 import ToastHost 时可能早于
// Vue.use(toast) 求值，组件会拿到 undefined。顶层创建与 import 顺序无关。
export const toastStore = Vue.observable({ items: [] })

// 各类型默认存留时长（ms）：错误文案可能较长，给更久阅读时间
const DURATION = { success: 2500, warning: 3500, error: 4500, info: 3000 }
const MAX_ITEMS = 4 // 同屏最多 4 条，超出淘汰最旧

// 定时器句柄放模块级 Map，不放 observable —— 避免句柄被 Vue 转成响应式数据
const timers = new Map()
let seq = 0

function remove(id) {
  const i = toastStore.items.findIndex(t => t.id === id)
  if (i > -1) toastStore.items.splice(i, 1)
  clearTimeout(timers.get(id))
  timers.delete(id)
}

function schedule(item) {
  clearTimeout(timers.get(item.id))
  timers.set(item.id, setTimeout(() => remove(item.id), item.duration))
}

export function toast(options) {
  const opts = typeof options === 'string' ? { message: options } : (options || {})
  const type = DURATION[opts.type] ? opts.type : 'info'

  // 后端返回的 msg 可能是任意类型；空 / 纯空白不弹空盒子
  const message = opts.message == null ? '' : String(opts.message).trim()
  if (!message) return

  // 同 type + 同内容已在屏：不重复堆叠，只续期（防连点、防重复提交刷屏）
  const dup = toastStore.items.find(t => t.type === type && t.message === message)
  if (dup) {
    schedule(dup)
    return
  }

  const item = {
    id: ++seq,
    type,
    message,
    duration: opts.duration > 0 ? opts.duration : DURATION[type]
  }
  toastStore.items.push(item)
  while (toastStore.items.length > MAX_ITEMS) {
    remove(toastStore.items[0].id) // 先移除最旧一条，绝不拒收新消息
  }
  schedule(item)
}

// 简写，便于后续新代码书写
toast.success = m => toast({ type: 'success', message: m })
toast.error = m => toast({ type: 'error', message: m })
toast.warning = m => toast({ type: 'warning', message: m })
toast.info = m => toast({ type: 'info', message: m })

// 供 ToastHost 卸载时清理，避免悬空定时器
export function clearAll() {
  ;[...toastStore.items].forEach(t => remove(t.id))
  timers.clear()
}

export default {
  install(Vue) {
    Vue.prototype.$toast = toast
  }
}



// WEBPACK FOOTER //
// ./src/utils/toast.js